import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllCoursesByPersonUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllCoursesByPerson
  implements GetAllCoursesByPersonUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetAllCoursesByPersonUseCaseInterface.Params,
  ): Promise<GetAllCoursesByPersonUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.personHashId}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
